import React from 'react';
import PropTypes from "prop-types";

import styles from '../../styles.less';
import LoadingStatus from '../LoadingStatus/LoadingStatus';
import ErrorBoundary from '../Utils/ErrorBoundary/ErrorBoundary';

const GeoHierarchyPageTab = ({ tabId, statuses, render, isVisible = true, isSidebarDesktopExpanded }) => {
  const paddingToUse = !isSidebarDesktopExpanded ? styles.smallPaddingLeftDesktop : styles.largePaddingLeftDesktop;

  return (
    <div
      id={`tab-${tabId}`}
      style={{ display: isVisible ? 'block' : 'none' }}
      className={`grid-item one-whole ${paddingToUse}`}
    >
      <LoadingStatus status={statuses || []}>{() => <ErrorBoundary>{render()}</ErrorBoundary>}</LoadingStatus>
    </div>
  );
};

GeoHierarchyPageTab.propTypes = {
  tabId: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
  statuses: PropTypes.array,
  isVisible: PropTypes.bool,
  isSidebarDesktopExpanded: PropTypes.bool,
};

export default GeoHierarchyPageTab;
